import { render, staticRenderFns } from "./SavePopupErrors.vue?vue&type=template&id=31da208f"
import script from "./SavePopupErrors.vue?vue&type=script&lang=js"
export * from "./SavePopupErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports